module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (parseInt(_vm.item.Quan_price) != 0 || _vm.isWeixin) ? _c('div', {
    staticClass: "doublemain",
    on: {
      "click": function($event) {
        _vm.public.gotoDetail(_vm.item, _vm.types, _vm.idx)
      }
    }
  }, [_c('div', {
    staticClass: "row product-list"
  }, [_c('div', {
    staticClass: "list-product-img1"
  }, [_c('img', {
    attrs: {
      "src": _vm.updatePicSrc(_vm.item.Pic),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "list-product-desc1"
  }, [_c('div', {
    staticClass: "list-product-name1"
  }, [_vm._v("\n        " + _vm._s(_vm._f("limitStr")(_vm.item.D_title, 11)) + "\n      ")]), _vm._v(" "), (_vm.type == _vm.showType.APP) ? _c('div', {
    staticClass: "list-prices"
  }, [_c('div', {
    staticClass: "list-quan1"
  }, [_c('span', {
    staticStyle: {
      "color": "#d90000"
    }
  }, [_vm._v("¥")]), _c('span', {
    staticClass: "list-quan1-price"
  }, [_vm._v(_vm._s(_vm.item.Price))]), _vm._v(_vm._s(_vm.quanDesc) + "\n        ")]), _vm._v(" "), _c('div', {
    class: _vm.showClass()
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowQuan),
      expression: "isShowQuan"
    }],
    staticClass: "list-price1-price"
  }, [_vm._v(_vm._s(_vm._f("subPrice")(_vm.item.Quan_price)) + "元券")])]), _vm._v(" "), _c('div', {
    staticClass: "red-box-main"
  }, [_c('div', {
    staticClass: "score"
  }, [_vm._v("返" + _vm._s(_vm.returnScore()) + "积分")]), _vm._v(" "), _c('div', {
    staticClass: "salenum"
  }, [_vm._v(_vm._s(_vm.item.Sales_num) + "笔成交")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _c('div', {
    staticClass: "list-prices-h5"
  }, [_c('div', {
    staticClass: "list-quan1-h5"
  }, [_c('div', {
    staticClass: "list-price1-quan-h5"
  }, [_c('span', {
    staticStyle: {
      "color": "#d90000"
    }
  }, [_vm._v("¥")]), _c('span', {
    directives: [{
      name: "priceLimit",
      rawName: "v-priceLimit",
      value: (_vm.item.Price),
      expression: "item.Price"
    }],
    staticClass: "list-quan1-price-h5"
  }, [_vm._v(_vm._s(_vm.item.Price))]), _c('span', {
    staticClass: "list-quan1-desc-price-h5"
  }, [_vm._v(_vm._s(_vm.quanDesc))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowQuan),
      expression: "isShowQuan"
    }],
    staticClass: "list-price1-price-h5"
  }, [_vm._v(_vm._s(_vm._f("subPrice")(_vm.item.Quan_price)) + "元券")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.showClass()
  }, [_c('div', {
    staticClass: "salenum-h5"
  }, [_vm._v(_vm._s(_vm.item.Sales_num) + "笔成交")])])])])])]) : _c('a', {
    staticClass: "doublemain",
    attrs: {
      "biz-itemid": _vm.item.GoodsID,
      "isconvert": "1",
      "target": "_self",
      "href": 'https://item.taobao.com/item.htm?id=' + _vm.item.GoodsID
    }
  }, [_c('div', {
    staticClass: "row product-list"
  }, [_c('div', {
    staticClass: "list-product-img1"
  }, [_c('img', {
    attrs: {
      "src": _vm.updatePicSrc(_vm.item.Pic),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "list-product-desc1"
  }, [_c('div', {
    staticClass: "list-product-name1"
  }, [_vm._v("\n        " + _vm._s(_vm._f("limitStr")(_vm.item.D_title, 11)) + "\n      ")]), _vm._v(" "), (_vm.type == _vm.showType.APP) ? _c('div', {
    staticClass: "list-prices"
  }, [_c('div', {
    staticClass: "list-quan1"
  }, [_c('span', {
    staticStyle: {
      "color": "#d90000"
    }
  }, [_vm._v("¥")]), _c('span', {
    staticClass: "list-quan1-price"
  }, [_vm._v(_vm._s(_vm.item.Price))]), _vm._v(_vm._s(_vm.quanDesc) + "\n        ")]), _vm._v(" "), _c('div', {
    class: _vm.showClass()
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowQuan),
      expression: "isShowQuan"
    }],
    staticClass: "list-price1-price"
  }, [_vm._v(_vm._s(_vm._f("subPrice")(_vm.item.Quan_price)) + "元券")])]), _vm._v(" "), _c('div', {
    staticClass: "red-box-main"
  }, [_c('div', {
    staticClass: "score"
  }, [_vm._v("返" + _vm._s(_vm.returnScore()) + "积分")]), _vm._v(" "), _c('div', {
    staticClass: "salenum"
  }, [_vm._v(_vm._s(_vm.item.Sales_num) + "笔成交")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _c('div', {
    staticClass: "list-prices-h5"
  }, [_c('div', {
    staticClass: "list-quan1-h5"
  }, [_c('div', {
    staticClass: "list-price1-quan-h5"
  }, [_c('span', {
    staticStyle: {
      "color": "#d90000"
    }
  }, [_vm._v("¥")]), _c('span', {
    directives: [{
      name: "priceLimit",
      rawName: "v-priceLimit",
      value: (_vm.item.Price),
      expression: "item.Price"
    }],
    staticClass: "list-quan1-price-h5"
  }, [_vm._v(_vm._s(_vm.item.Price))]), _c('span', {
    staticClass: "list-quan1-desc-price-h5"
  }, [_vm._v(_vm._s(_vm.quanDesc))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowQuan),
      expression: "isShowQuan"
    }],
    staticClass: "list-price1-price-h5"
  }, [_vm._v(_vm._s(_vm._f("subPrice")(_vm.item.Quan_price)) + "元券")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.showClass()
  }, [_c('div', {
    staticClass: "salenum-h5"
  }, [_vm._v(_vm._s(_vm.item.Sales_num) + "笔成交")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c286058","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/Double.vue
// module id = 196
// module chunks = 2